import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { Route, Routes } from 'react-router-dom';
import List from './pages/List';
import Edit from './pages/Edit';

const CoursesComponent = ({ ...props }) => {
    return (
        <Routes>
            <Route
                index
                element={<List />}
            />
            <Route
                path="/edit"
                element={<Edit />}
            />
        </Routes>
    );
};

CoursesComponent.displayName = 'Courses';

const Courses = (props) => {
    return (
        <ErrorWrapper>
            <CoursesComponent
                data-id="Courses-Student-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default Courses;
